<div class="p-3">
  <div class="row mb-3">
    <div class="col-3">
      <button mat-raised-button color="primary" (click)="onRecargarUsuarios()" [disabled]="isLoadingUsuarios">
        <mat-icon>refresh</mat-icon>
        Recargar Usuarios
      </button>
    </div>
  </div>

  <div *ngIf="isLoadingUsuarios" class="mb-3">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <table mat-table [dataSource]="dataSourceUsuarios" class="w-100 usuarios-table" *ngIf="dataSourceUsuarios.data.length">
    <ng-container matColumnDef="userId">
      <th mat-header-cell *matHeaderCellDef>ID Usuario</th>
      <td mat-cell *matCellDef="let element">{{ element.userId }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Correo</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>

    <ng-container matColumnDef="userTypeId">
      <th mat-header-cell *matHeaderCellDef>Tipo</th>
      <td mat-cell *matCellDef="let element">{{ element.userTypeId }}</td>
    </ng-container>

    <ng-container matColumnDef="creationDate">
      <th mat-header-cell *matHeaderCellDef>Creacion</th>
      <td mat-cell *matCellDef="let element">{{ element.creationDate | date:'yyyy-MM-dd' }}</td>
    </ng-container>

    <ng-container matColumnDef="lastLoginDate">
      <th mat-header-cell *matHeaderCellDef>Ultimo Login</th>
      <td mat-cell *matCellDef="let element">{{ element.lastLoginDate ? (element.lastLoginDate | date:'yyyy-MM-dd HH:mm') : '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="lastActivity">
      <th mat-header-cell *matHeaderCellDef>Ultima Actividad</th>
      <td mat-cell *matCellDef="let element">{{ element.lastActivity ? (element.lastActivity | date:'yyyy-MM-dd HH:mm') : '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="carteras">
      <th mat-header-cell *matHeaderCellDef>Carteras</th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.carteras > 0; else sinCarteras" href="javascript:void(0)" (click)="verDetalle(element)" matTooltip="Ver carteras">
          {{ element.carteras }}
        </a>
        <ng-template #sinCarteras>0</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="validDays">
      <th mat-header-cell *matHeaderCellDef>Dias Vigentes</th>
      <td mat-cell *matCellDef="let element" class="valid-days-cell">
        <button
          type="button"
          mat-icon-button
          color="primary"
          (click)="onAjustarValidDays(element, -1)"
          [disabled]="isLoadingUsuarios"
          matTooltip="Restar dia"
        >
          <mat-icon>remove</mat-icon>
        </button>
        <span class="valid-days-value">{{ element.validDays }}</span>
        <button
          type="button"
          mat-icon-button
          color="primary"
          (click)="onAjustarValidDays(element, 1)"
          [disabled]="isLoadingUsuarios"
          matTooltip="Agregar dia"
        >
          <mat-icon>add</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>Duracion</th>
      <td mat-cell *matCellDef="let element">{{ element.duration }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="primary" (click)="verDetalle(element)" matTooltip="Ver detalle">
          <mat-icon>info</mat-icon>
        </button>
        <button class="btn btn-danger" (click)="onEliminarUsuario(element)" [disabled]="isLoadingUsuarios" matTooltip="Eliminar usuario">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsUsuarios"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsUsuarios"></tr>
  </table>

  <div *ngIf="!isLoadingUsuarios && !dataSourceUsuarios.data.length" class="text-muted">
    No hay usuarios disponibles.
  </div>
</div>

<ng-template #dialogoDetalle>
  <h2 mat-dialog-title>{{ usuarioDetalle?.email }}</h2>
  <mat-dialog-content>
    <div class="detalle-resumen">
      <div><strong>ID:</strong> {{ usuarioDetalle?.userId }}</div>
      <div><strong>Ultimo login:</strong> {{ usuarioDetalle?.lastLoginDate ? (usuarioDetalle?.lastLoginDate | date:'yyyy-MM-dd HH:mm') : '—' }}</div>
      <div><strong>Ultima actividad:</strong> {{ usuarioDetalle?.lastActivity ? (usuarioDetalle?.lastActivity | date:'yyyy-MM-dd HH:mm') : '—' }}</div>
    </div>

    <h3 class="detalle-titulo">Carteras guardadas ({{ carterasDetalle.length }})</h3>
    <mat-progress-bar *ngIf="isLoadingDetalle" mode="indeterminate"></mat-progress-bar>

    <table mat-table [dataSource]="carterasDetalle" class="w-100 usuarios-table" *ngIf="!isLoadingDetalle && carterasDetalle.length">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let c">{{ c.nombre }}</td>
      </ng-container>
      <ng-container matColumnDef="mercado">
        <th mat-header-cell *matHeaderCellDef>Mercado</th>
        <td mat-cell *matCellDef="let c">{{ c.mercado || c.idmercado }}</td>
      </ng-container>
      <ng-container matColumnDef="capitalinicial">
        <th mat-header-cell *matHeaderCellDef>Capital Inicial</th>
        <td mat-cell *matCellDef="let c">{{ c.capitalinicial | number:'1.0-2' }}</td>
      </ng-container>
      <ng-container matColumnDef="simulado">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let c">{{ c.simulado ? 'Simulada' : 'Real' }}</td>
      </ng-container>
      <ng-container matColumnDef="auto">
        <th mat-header-cell *matHeaderCellDef>Auto</th>
        <td mat-cell *matCellDef="let c">{{ c.auto ? 'Si' : 'No' }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsCarteras"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsCarteras"></tr>
    </table>

    <div *ngIf="!isLoadingDetalle && !carterasDetalle.length" class="text-muted">
      El usuario no tiene carteras guardadas.
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cerrar</button>
  </mat-dialog-actions>
</ng-template>
